/**
 * Die große, naturgetreu-farbige Spaghetti-Eis-Illustration (Teller, Nudelberg
 * mit Textur, Erdbeersauce-Tropfen, Waffel, Löffel). Feste Naturfarben statt
 * einfärbbar — die Bewertungsstufe wird daneben über GuennieBalken angezeigt
 * (siehe GuennieRating). Für kleine, einfärbbare Kontexte (Kartenmarker,
 * -legende, Marken-Icon) siehe GuennieIcon.
 */
export function GuennieEisBild({ groesse = 64, titel }: { groesse?: number; titel?: string }) {
  const breite = groesse;
  const hoehe = (groesse * 100) / 120;

  return (
    <svg
      width={breite}
      height={hoehe}
      viewBox="0 0 120 100"
      role="img"
      aria-label={titel}
      aria-hidden={titel ? undefined : true}
    >
      {titel ? <title>{titel}</title> : null}
      <defs>
        <clipPath id="guennie-eisbild-waffel">
          <path d="M38 18 L66 14 L52 48 Z" />
        </clipPath>
      </defs>

      <ellipse cx="60" cy="83" rx="54" ry="13" fill="#ffffff" stroke="#4a4a4a" strokeWidth="2" />
      <ellipse cx="60" cy="80" rx="45" ry="8.5" fill="none" stroke="#d8d8d6" strokeWidth="1.4" />

      <path
        d="M18 76 C15 55 30 40 45 38 C50 30 62 28 68 35 C78 32 90 42 88 54 C98 58 100 72 90 78 C92 82 88 85 82 85 L24 85 C18 85 16 80 18 76 Z"
        fill="#f2ede1"
        stroke="#4a4a4a"
        strokeWidth="2"
      />

      <g fill="none" stroke="#c7bfa8" strokeWidth="1" strokeLinecap="round">
        <path d="M28 60 q3 -3 6 0 q3 3 6 0" />
        <path d="M36 68 q3 -3 6 0 q3 3 6 0" />
        <path d="M46 74 q3 -3 6 0 q3 3 6 0" />
        <path d="M58 70 q3 -3 6 0 q3 3 6 0" />
        <path d="M68 76 q3 -3 6 0 q3 3 6 0" />
        <path d="M76 66 q3 -3 6 0 q3 3 6 0" />
        <path d="M30 50 q3 -3 6 0 q3 3 6 0" />
        <path d="M60 48 q3 -3 6 0 q3 3 6 0" />
        <path d="M78 54 q3 -3 6 0 q3 3 6 0" />
        <path d="M42 58 q3 -3 6 0 q3 3 6 0" />
        <path d="M52 62 q3 -3 6 0 q3 3 6 0" />
        <path d="M66 58 q3 -3 6 0 q3 3 6 0" />
      </g>

      <g stroke="#8f1a1f" strokeWidth="1">
        <path
          d="M22 59 C22 56 28 56 28 59 C28.4 63.5 26.3 67 27.3 71.5 C27.8 74 29 76.5 26.5 78.5 C24 76.5 25.2 74 25.7 71.5 C26.7 67 24.6 63.5 25 59 Z"
          fill="#c8262c"
        />
        <path
          d="M48.5 43.5 C48.5 40 55.5 40 55.5 43.5 C56 48 54 51 55.5 55 C57 59 54.5 62 55.5 66 C56.3 69 54.5 70.5 55 72.5 C55.2 74.5 52 76 51.5 74 C51 72 49.5 70.5 50 68.5 C50.8 65 48.5 62 49.5 58 C50.5 54 48 50 48.5 43.5 Z"
          fill="#c8262c"
        />
        <path
          d="M58 59 C58 57 62 57 62 59 C62.3 62 61 64.5 61.7 67.5 C62 69 60.5 70 60 68.5 C59.5 66.5 58.3 64.5 58.6 62 Z"
          fill="#c8262c"
        />
        <path
          d="M75 48 C75 45 81 45 81 48 C81.4 52 79.5 55 80.5 59 C81.3 62.5 79 65.5 79.8 69 C80.2 71 78 72 77.6 70 C77 67.5 75.5 64.5 76.3 61 C77.1 57.5 75 52.5 75 48 Z"
          fill="#c8262c"
        />
        <path
          d="M89 61 C89 58 95 58 95 61 C95.4 65.5 93.3 69 94.3 73.5 C94.8 76 96 78.5 93.5 80.5 C91 78.5 92.2 76 92.7 73.5 C93.7 69 91.6 65.5 92 61 Z"
          fill="#c8262c"
        />
      </g>
      <circle cx="51.5" cy="76.5" r="1.6" fill="#c8262c" stroke="#8f1a1f" strokeWidth="0.7" />
      <circle cx="26.2" cy="80.5" r="1.3" fill="#c8262c" stroke="#8f1a1f" strokeWidth="0.7" />

      <g fill="none" stroke="#e2686c" strokeWidth="1" strokeLinecap="round" opacity="0.9">
        <path d="M24.5 60 C24.3 64 23.7 67 24.3 70" />
        <path d="M50.5 44 C50 49 49 53 50 58" />
        <path d="M77 49.5 C76.7 53 76 56 76.7 60" />
        <path d="M91.5 61 C91.3 65 90.7 68 91.3 71" />
      </g>
      <g fill="#ffffff" opacity="0.9">
        <ellipse cx="24" cy="59.5" rx="0.8" ry="1.4" transform="rotate(20 24 59.5)" />
        <ellipse cx="51" cy="43.5" rx="0.9" ry="1.7" transform="rotate(20 51 43.5)" />
        <ellipse cx="59" cy="58" rx="0.7" ry="1.2" transform="rotate(20 59 58)" />
        <ellipse cx="77" cy="48.5" rx="0.8" ry="1.4" transform="rotate(20 77 48.5)" />
        <ellipse cx="91" cy="60.5" rx="0.8" ry="1.4" transform="rotate(20 91 60.5)" />
      </g>

      <path d="M38 18 L66 14 L52 48 Z" fill="#dba04a" stroke="#4a4a4a" strokeWidth="2" strokeLinejoin="round" />
      <g clipPath="url(#guennie-eisbild-waffel)" stroke="#8a5a2a" strokeWidth="1">
        <path d="M32 22 L58 46" />
        <path d="M38 20 L64 44" />
        <path d="M44 18 L70 42" />
        <path d="M50 16 L76 40" />
        <path d="M30 30 L70 20" />
        <path d="M30 38 L70 28" />
        <path d="M30 46 L70 36" />
      </g>

      <path
        d="M6 94 C14 87 28 82 42 80 C46.5 79.4 48.5 81.5 47 84.5 C36 86.5 22 91 12 98 C8.5 100.3 3 97 6 94 Z"
        fill="#dfe1e2"
        stroke="#4a4a4a"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <ellipse
        cx="53"
        cy="80.5"
        rx="10.5"
        ry="6.5"
        transform="rotate(-14 53 80.5)"
        fill="#dfe1e2"
        stroke="#4a4a4a"
        strokeWidth="1.8"
      />
      <path d="M48 78.5 C50 77.3 53 77 55.5 78" stroke="#ffffff" strokeWidth="1" fill="none" opacity="0.8" />
    </svg>
  );
}
